import { Component } from 'vue-property-decorator';
import StudioModalMobile from '@/components/modals/StudioModalMobile.vue';
import Base from '@/components/Base';
import { EModalName } from '@/helpers/modal';
import { Guard, TextInput } from 'streamlabs-beaker';
import RTMPApi from '@/apis/rtmp-api';

@Component({
  components: {
    StudioModalMobile,
    SGuard: Guard,
    STextInput: TextInput,
  },
})
export default class RTMPInfoModal extends Base {
  RTMPAddress: string = null;
  streamKey: string = null;

  async mounted() {
    const response = await RTMPApi.getSettings();

    this.RTMPAddress = response.RTMPAddress;
    this.streamKey = response.streamKey;
  }
  get modalName(): string {
    return EModalName.RTMPInfoModal;
  }

  hideModal() {
    this.$modal.hide(this.modalName);
  }
}
